@if (event.scoreboard.started && !penaltyShootout) {
    @if (event.scoreboard.type === scoreboardType.SetGame) {
        <ms-set-game-scoreboard-header [scoreboard]="event.scoreboard" />
    }
    @if (event.scoreboard.type === scoreboardType.Snooker) {
        <ms-snooker-scoreboard-header [scoreboard]="event.scoreboard" />
    }
    @if (event.scoreboard.type === scoreboardType.Darts) {
        <ms-darts-scoreboard-header [scoreboard]="event.scoreboard" />
    }
}
